export default
  [
    {
      "login": "ramanic",
      "id": 40167289,
      "node_id": "MDQ6VXNlcjQwMTY3Mjg5",
      "avatar_url": "https://avatars.githubusercontent.com/u/40167289?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/ramanic",
      "html_url": "https://github.com/ramanic",
      "followers_url": "https://api.github.com/users/ramanic/followers",
      "following_url": "https://api.github.com/users/ramanic/following{/other_user}",
      "gists_url": "https://api.github.com/users/ramanic/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/ramanic/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/ramanic/subscriptions",
      "organizations_url": "https://api.github.com/users/ramanic/orgs",
      "repos_url": "https://api.github.com/users/ramanic/repos",
      "events_url": "https://api.github.com/users/ramanic/events{/privacy}",
      "received_events_url": "https://api.github.com/users/ramanic/received_events",
      "type": "User",
      "site_admin": false
    },
    {
      "login": "help",
      "id": 4016728,
      "html_url": "https://github.com/ramanic",
    },
    {
      "login": "help",
      "id": 4016789,
      "html_url": "https://github.com/ramanic",
    },
    {
      "login": "help",
      "id": 40167,
      "html_url": "https://github.com/ramanic",
    },
    {
      "login": "help",
      "id": 3167289,
      "html_url": "https://github.com/ramanic",
    },
    {
      "login": "help",
      "id": 4067289,
      "html_url": "https://github.com/ramanic",
    },
    {
      "login": "help",
      "id": 401672893,
      "html_url": "https://github.com/ramanic",
    },
    {
      "login": "help",
      "id": 40167249,
      "html_url": "https://github.com/ramanic",
    },
    {
      "login": "help",
      "id": 4016728966,
      "html_url": "https://github.com/ramanic",
    },

  ]